export default __webpack_public_path__ + "img/363aa0ccd38652bd571fc8aeff2203a5.png";